import * as React from "react";
import { Path, Rect, G, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const CVIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="CV" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#4141DB"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path fill="#F90000" stroke="#F7FCFF" d="M16.5 6.5v2h-17v-2h17Z" />
        <G filter="url(#c)">
          <Path
            fill="#FFDE00"
            d="M6.76 4.057h.525l-.412.416.142.584h.298l.206-.536.242.536h.524l-.412.416.142.584h.298l.206-.536.242.536h.524l-.412.416.142.584h.27l-.412.416.142.584h.27l-.412.416.16.657-.514-.37-.423.297h.189l-.412.416.16.657-.514-.37-.423.297h.189l-.412.416.16.657-.514-.37-.494.345.007.025-.021-.016-.02.016.006-.026-.478-.343-.494.344.007.025-.021-.016-.02.016.006-.026-.478-.343-.529.369.179-.657-.47-.416h.232l-.412-.296-.529.369.179-.657-.47-.416h.232l-.412-.296-.529.369.179-.657-.47-.416h.31l.16-.584-.47-.416h.31l.16-.584-.47-.416h.614l.206-.536.242.536h.249l.159-.584-.47-.416h.614l.206-.536.242.536h.249l.159-.584-.47-.416h.614l.206-.536.242.536h.552l.206-.536.242.536h.552l.206-.536.242.536Zm-1.887 6.416.139.575.157-.575-.158-.14-.138.14Zm1 0 .139.575.157-.575-.158-.14-.138.14Zm.152-5.369.007.026-.021-.016-.02.016.006-.026-.478-.343-.494.343.007.026-.021-.016-.02.016.006-.026-.478-.343-.423.296h.189l-.412.416.16.657-.514-.37-.423.297h.189l-.412.416.142.584h.27l-.412.416.142.584h.27l-.412.416.142.584h.298l.206-.536.242.536h.524l-.412.416.142.584h.298l.206-.536.242.536h.552l.206-.536.242.536h.552l.206-.536.242.536h.249l.159-.584-.47-.416h.614l.206-.536.242.536h.249l.159-.584-.47-.416h.31l.16-.584-.47-.416h.31l.16-.584-.47-.416h.232l-.412-.296-.529.369.179-.657-.47-.416h.232l-.412-.296-.494.343Zm-3.93 2.953h.218l.08-.208-.297.208Zm.666 0h.17l-.252-.182.082.182Zm5.335 0h.217l.08-.208-.297.208Zm.665 0h.17l-.252-.182.082.182Zm-6.665-1h.217l.08-.208-.297.208Zm.665 0h.17l-.252-.182.082.182Zm5.335 0h.217l.08-.208-.297.208Zm.665 0h.17l-.252-.182.082.182ZM4.873 4.473l.139.575.157-.575-.158-.14-.138.14Zm1 0 .139.575.157-.575-.158-.14-.138.14Z"
          />
        </G>
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
